// Import all SVGs
import alabama from '../Assets/states/alabama.svg';
import alaska from '../Assets/states/alaska.svg';
import arizona from '../Assets/states/arizona.svg';
import arkansas from '../Assets/states/arkansas.svg';
import california from '../Assets/states/california.svg';
import colorado from '../Assets/states/colorado.svg';
import connecticut from '../Assets/states/connecticut.svg';
import delaware from '../Assets/states/delaware.svg';
import florida from '../Assets/states/florida.svg';
import georgia from '../Assets/states/georgia.svg';
import hawaii from '../Assets/states/hawaii.svg';
import idaho from '../Assets/states/idaho.svg';
import illinois from '../Assets/states/illinois.svg';
import indiana from '../Assets/states/indiana.svg';
import iowa from '../Assets/states/iowa.svg';
import kansas from '../Assets/states/kansas.svg';
import kentucky from '../Assets/states/kentucky.svg';
import louisiana from '../Assets/states/louisiana.svg';
import maine from '../Assets/states/maine.svg';
import maryland from '../Assets/states/maryland.svg';
import massachusetts from '../Assets/states/massachusetts.svg';
import michigan from '../Assets/states/michigan.svg';
import minnesota from '../Assets/states/minnesota.svg';
import mississippi from '../Assets/states/mississippi.svg';
import missouri from '../Assets/states/missouri.svg';
import montana from '../Assets/states/montana.svg';
import nebraska from '../Assets/states/nebraska.svg';
import nevada from '../Assets/states/nevada.svg';
import newHampshire from '../Assets/states/newHampshire.svg';
import newJersey from '../Assets/states/newJersey.svg';
import newMexico from '../Assets/states/newMexico.svg';
import newYork from '../Assets/states/newYork.svg';
import northCarolina from '../Assets/states/northCarolina.svg';
import northDakota from '../Assets/states/northDakota.svg';
import ohio from '../Assets/states/ohio.svg';
import oklahoma from '../Assets/states/oklahoma.svg';
import oregon from '../Assets/states/oregon.svg';
import pennsylvania from '../Assets/states/pennsylvania.svg';
import rhodeIsland from '../Assets/states/rhodeIsland.svg';
import southCarolina from '../Assets/states/southCarolina.svg';
import southDakota from '../Assets/states/southDakota.svg';
import tennessee from '../Assets/states/tennessee.svg';
import texas from '../Assets/states/texas.svg';
import utah from '../Assets/states/utah.svg';
import vermont from '../Assets/states/vermont.svg';
import virginia from '../Assets/states/virginia.svg';
import washington from '../Assets/states/washington.svg';
import westVirginia from '../Assets/states/westVirginia.svg';
import wisconsin from '../Assets/states/wisconsin.svg';
import wyoming from '../Assets/states/wyoming.svg';

// Map state codes to SVG imports
const stateIcons = {
  AL: alabama,
  AK: alaska,
  AZ: arizona,
  AR: arkansas,
  CA: california,
  CO: colorado,
  CT: connecticut,
  DE: delaware,
  FL: florida,
  GA: georgia,
  HI: hawaii,
  ID: idaho,
  IL: illinois,
  IN: indiana,
  IA: iowa,
  KS: kansas,
  KY: kentucky,
  LA: louisiana,
  ME: maine,
  MD: maryland,
  MA: massachusetts,
  MI: michigan,
  MN: minnesota,
  MS: mississippi,
  MO: missouri,
  MT: montana,
  NE: nebraska,
  NV: nevada,
  NH: newHampshire,
  NJ: newJersey,
  NM: newMexico,
  NY: newYork,
  NC: northCarolina,
  ND: northDakota,
  OH: ohio,
  OK: oklahoma,
  OR: oregon,
  PA: pennsylvania,
  RI: rhodeIsland,
  SC: southCarolina,
  SD: southDakota,
  TN: tennessee,
  TX: texas,
  UT: utah,
  VT: vermont,
  VA: virginia,
  WA: washington,
  WV: westVirginia,
  WI: wisconsin,
  WY: wyoming,
};

// Function to get the SVG based on state code
export const getStateIcon = (stateCode) => {
  return stateIcons[stateCode] || null; // Return null if SVG is not found
};
